import { GetDamagedAdjusterImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQuery.type';
import { getDamagedAdjusterImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getDamagedAdjusterImagesQueryOptions = (
  params: GetDamagedAdjusterImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getDamagedAdjusterImages', params],
    queryFn: () => getDamagedAdjusterImagesFunction(params),
    enabled: params.enable,
    select: (data) => {
      const vehicle = data.vehicle.map((item) => ({
        id: item.id,
        url: item.image,
        label: item?.title?.fa_const,
        en_name: item?.title?.const,
      }));
      const damaged_parts = data.damaged_parts.map((item) => ({
        id: item.id,
        part_id: item.part_id,
        url: item.image,
        label: item.title?.fa_const,
        en_name: item.title?.const,
      }));
      return { vehicle, damaged_parts };
    },
  });
};
